/* __next_internal_client_entry_do_not_use__ Amex auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { createSVGIcon } from "../util";
// https://docs.adyen.com/online-payments/api-only/downloading-logos
var SquareLogo = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M37 39.75H3C1.48122 39.75 0.25 38.5188 0.25 37V3C0.25 1.48122 1.48122 0.25 3 0.25H37C38.5188 0.25 39.75 1.48122 39.75 3V37C39.75 38.5188 38.5188 39.75 37 39.75Z",
            fill: "#016FD0",
            stroke: "#AAAAAA",
            strokeWidth: "0.5"
        }),
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M30.6898 20.33V21.97H26.5198V23.11H30.5898V24.75H26.5198V25.87H30.6898V27.53L34.0698 23.93L30.6898 20.33V20.33ZM29.5898 14.19L28.1898 11H24.1898L20.0898 20.32H23.4198V28.59L33.6998 28.6L35.3098 26.8L36.9398 28.6H39.9998V25.97L38.0798 23.91L39.9998 21.86V19.27L38.0698 19.28V14.3L36.2598 19.28H34.4998L32.6398 14.28V19.28H28.4398L27.8398 17.82H24.5398L23.9398 19.28H21.7198L24.9498 12.01V12H27.4998L30.6898 19.21V12L33.7898 12.01L35.3898 16.48L37.0098 12H39.9998V11H36.2298L35.3798 13.39L34.5298 11H29.5898V14.19V14.19ZM24.5298 20.3V27.57H30.6898V27.56H33.2298L35.3298 25.24L37.4498 27.56H39.9998V27.46L36.6598 23.93L39.9998 20.35V20.3H37.4798L35.3798 22.6L33.2998 20.3H24.5298V20.3ZM25.2298 16.19L26.1898 13.88L27.1598 16.19H25.2298Z",
            fill: "white"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M37 39.75H3C1.48122 39.75 0.25 38.5188 0.25 37V3C0.25 1.48122 1.48122 0.25 3 0.25H37C38.5188 0.25 39.75 1.48122 39.75 3V37C39.75 38.5188 38.5188 39.75 37 39.75Z",
            stroke: "#AAAAAA",
            strokeWidth: "0.5"
        })
    ]
}), "AmexSquare", {
    viewBox: "0 0 40 40",
    titleAccess: "Square Amex Icon",
    fill: "none"
});
var Logo = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M0 23C0 24.6569 1.34315 26 3 26H37C38.6569 26 40 24.6569 40 23V3C40 1.34315 38.6569 0 37 0H3C1.34315 0 0 1.34315 0 3V23Z",
            fill: "#016FD0"
        }),
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M30.6898 13.6298V15.2698H26.5198V16.4098H30.5898V18.0498H26.5198V19.1698H30.6898V20.8298L34.0698 17.2298L30.6898 13.6298ZM29.5898 7.4898L28.1898 4.2998H24.1898L20.0898 13.6198H23.4198V21.8898L33.6998 21.8998L35.3098 20.0998L36.9398 21.8998H39.9998V19.2698L38.0798 17.2098L39.9998 15.1598V12.5698L38.0698 12.5798V7.5998L36.2598 12.5798H34.4998L32.6398 7.5798V12.5798H28.4398L27.8398 11.1198H24.5398L23.9398 12.5798H21.7198L24.9498 5.3098V5.2998H27.4998L30.6898 12.5098V5.2998L33.7898 5.3098L35.3898 9.7798L37.0098 5.2998H39.9998V4.2998H36.2298L35.3798 6.6898L34.5298 4.2998H29.5898V7.4898ZM24.5298 13.5998V20.8698H30.6898V20.8598H33.2298L35.3298 18.5398L37.4498 20.8598H39.9998V20.7598L36.6598 17.2298L39.9998 13.6498V13.5998H37.4798L35.3798 15.8998L33.2998 13.5998H24.5298ZM25.2298 9.4898L26.1898 7.1798L27.1598 9.4898H25.2298Z",
            fill: "white"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M37 25.75H3C1.48122 25.75 0.25 24.5188 0.25 23V3C0.25 1.48122 1.48122 0.25 3 0.25H37C38.5188 0.25 39.75 1.48122 39.75 3V23C39.75 24.5188 38.5188 25.75 37 25.75Z",
            stroke: "#AAAAAA",
            strokeWidth: "0.5"
        }),
        /*#__PURE__*/ _jsx("rect", {
            x: "0.25",
            y: "0.25",
            width: "39.5",
            height: "25.5",
            rx: "2.75",
            stroke: "#AAAAAA",
            strokeWidth: "0.5"
        })
    ]
}), "Amex", {
    viewBox: "0 0 40 26",
    titleAccess: "Amex Icon",
    fill: "none"
});
export var Amex = /*#__PURE__*/ React.memo(/*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var square = _param.square, iconProps = _object_without_properties(_param, [
        "square"
    ]);
    var Icon = square ? SquareLogo : Logo;
    return /*#__PURE__*/ _jsx(Icon, _object_spread({
        ref: ref
    }, iconProps));
}));
